import { BUSINESS_TOOL_SECTIONS } from 'constants/businessTool';
import { FOR_INVESTORS_SECTIONS } from 'constants/businessToolSections/forInvestors';

import { PERIOD_NAMES } from 'components/BusinessToolForm/constants/periods';
import { ABOUT_COMPANY_HISTORY_NAMES } from 'components/BusinessToolForm/Sections/AboutCompany/CompanyHistory/utils/form';
import { ABOUT_COMPANY_MISSION_NAMES } from 'components/BusinessToolForm/Sections/AboutCompany/MissionAndVision/utils/form';
import { EQUIPMENT_NAMES } from 'components/BusinessToolForm/Sections/BusinessOperations/Equipment/utils/form';
import { LOCATION_AND_PREMISES_NAMES } from 'components/BusinessToolForm/Sections/BusinessOperations/LocationAndPremises/utils/form';
import { ASSETS_NAMES } from 'components/BusinessToolForm/Sections/BusinessOperations/OtherAssets/utils/form';
import { PARTNERS_NAMES } from 'components/BusinessToolForm/Sections/BusinessOperations/PartnersSection/utils/form';
import { PRODUCTION_NAMES } from 'components/BusinessToolForm/Sections/BusinessOperations/ProductionSection/utils/form';
import { QUALITY_NAMES } from 'components/BusinessToolForm/Sections/BusinessOperations/QualityControl/utils/form';
import { TECHNOLOGICAL_PROCESS_NAMES } from 'components/BusinessToolForm/Sections/BusinessOperations/TechnologicalProcess/utils/form';
import { WORKING_RESOURCES_NAMES } from 'components/BusinessToolForm/Sections/BusinessOperations/WorkingResources/utils/form';
import { EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES } from 'components/BusinessToolForm/Sections/ExecutiveSummary/FinancialInformationExecSummary/utils/form';
import { EXECUTIVE_SUMMARY_MARKET_NAMES } from 'components/BusinessToolForm/Sections/ExecutiveSummary/MarketExecSummary/utils/form';
import { EXECUTIVE_SUMMARY_RISKS_NAMES } from 'components/BusinessToolForm/Sections/ExecutiveSummary/RisksExecSummary/utils/form';
import { CALENDAR_PLAN_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/CashFlowElements/Sections/CalendarPlanForm/utils/form';
import { FUNDING_DIRECTIONS_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/CashFlowElements/Sections/FundingDirectionsForm/utils/form';
import { EFFICIENCY_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/FinancialPerformance/EfficiencyForm/utils/form';
import { INVESTMENT_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/FinancialPerformance/InvestmentForm/utils/form';
import { LIQUIDITY_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/FinancialPerformance/LiquidityForm/utils/form';
import { PROFITABILITY_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/FinancialPerformance/ProfitabilityForm/utils/form';
import { SOLVENCY_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/FinancialPerformance/SolvencyForm/utils/form';
import { INITIAL_ASSETS_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/OpeningBalanceSheets/InitialAssetsForm/utils/form';
import { EQUITY_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/OpeningBalanceSheets/InitialEquityForm/utils/form';
import { INITIAL_LIABILITIES_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/OpeningBalanceSheets/InitialLiabilitiesForm/utils/form';
import { COST_OF_EACH_UNIT_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/CostOfEachUnitForm/utils/form';
import { COST_OF_SALES_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/CostOfSalesForm/utils/form';
import { GENERAL_AND_ADMINISTRATIVE_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/GeneralAndAdministrativeForm/utils/form';
import { PERSONNEL_EXPENSES_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/PersonnelExpensesForm/utils/form';
import { R_AND_D_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/RAndDForm/utils/form';
import { SALES_AND_MARKETING_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/SalesAndMarketingForm/utils/form';
import { EXPENSE_TYPE_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/utils/form';
import { NET_INCOME_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProfitAndLossProjection/components/FormSections/NetIncome/utils/form';
import { NET_SALES_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProfitAndLossProjection/components/FormSections/NetSalesForm/utils/form';
import { OPERATING_EXPENSES_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProfitAndLossProjection/components/FormSections/OperatingExpensesForm/utils/form';
import { PROFIT_AND_LOSS_PROJECTION_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProfitAndLossProjection/utils/form';
import { PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedBalanceSheets/utils/form';
import { TOTAL_FIELDS } from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedCashFlow/DirectForm/DirectFormComponents/DirectFormTable/utils/form';
import { FINANCING_ACTIVITIES_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedCashFlow/DirectForm/DirectFormComponents/Sections/FinancingActivities/utils/form';
import { INVESTING_ACTIVITIES_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedCashFlow/DirectForm/DirectFormComponents/Sections/InvestingActivities/utils/form';
import { OPERATING_ACTIVITIES_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedCashFlow/DirectForm/DirectFormComponents/Sections/OperatingActivities/utils/form';
import { PROJECTED_CASH_FLOW_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedCashFlow/utils/form';
import { REVENUE_PLAN_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/RevenuePlan/utils/form';
import { ALL_FIELD_NAMES, GLOBAL_FIELD_NAMES } from 'components/BusinessToolForm/Sections/Global/form';
import { PRODUCT_NAMES } from 'components/BusinessToolForm/Sections/Global/general/products';
import { EXTERNAL_PARTNERS_AND_ADVISERS_NAMES } from 'components/BusinessToolForm/Sections/ManagementAndOrganization/ExternalPartners/utils/form';
import { MANAGEMENT_TEAM_NAMES } from 'components/BusinessToolForm/Sections/ManagementAndOrganization/ManagementTeam/utils/form';
import { STAFF_ORGANIZATION_NAMES } from 'components/BusinessToolForm/Sections/ManagementAndOrganization/StaffOrganization/utils/form';
import { B2C_NAMES } from 'components/BusinessToolForm/Sections/MarketAnalysis/ConsumerNeeds/utils/form';
import {
  AVERAGE_PRICES_CHART_NAMES,
  MARKET_ANALYSIS_OVERVIEW_NAMES,
} from 'components/BusinessToolForm/Sections/MarketAnalysis/MarketAnalysisOverview/utils/form';
import { COMPANY_OVERVIEW_NAMES } from 'components/BusinessToolForm/Sections/Overview/CompanyOverview/utils/form';
import { prefix as overviewCompanyPrefix } from 'components/BusinessToolForm/Sections/Overview/CompanyOverview/utils/form';
import {
  prefix,
  PRODUCTS_AND_SERVICES_ADVANTAGES_NAMES,
} from 'components/BusinessToolForm/Sections/ProductsAndServices/ProductAndServicesAdvantages/utils/form';
import {
  PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES,
  prefix as productsAndServicesDescriptionPrefix,
} from 'components/BusinessToolForm/Sections/ProductsAndServices/ProductAndServicesDescription/utils/form';
import { RAISING_AND_ALLOCATING_FUNDS_NAMES } from 'components/BusinessToolForm/Sections/RaisingAndAllocatingFunds/utils/form';

import { concatWithDot } from 'helpers/string';

export const overviewGlobalFieldNames = [
  GLOBAL_FIELD_NAMES.COMPANY_NAME,
  GLOBAL_FIELD_NAMES.REGISTRATION_DATE,
  GLOBAL_FIELD_NAMES.ADDRESS,
  GLOBAL_FIELD_NAMES.COMPANY_SECTOR,
  GLOBAL_FIELD_NAMES.NUMBER_OF_EMPLOYEES,
  GLOBAL_FIELD_NAMES.ANNUAL_INCOME,
  GLOBAL_FIELD_NAMES.MAIN_GOALS,
  GLOBAL_FIELD_NAMES.COMPANY_BRIEF_DESCRIPTION,
  GLOBAL_FIELD_NAMES.PROJECT_BRIEF_DESCRIPTION,
  GLOBAL_FIELD_NAMES.COVER_TITLE,
  GLOBAL_FIELD_NAMES.MAIN_PRODUCTS_OR_SERVICES,
  GLOBAL_FIELD_NAMES.STRATEGY_FOR_ACHIEVING_GOALS,
  GLOBAL_FIELD_NAMES.TARGET_MARKET,
  GLOBAL_FIELD_NAMES.TARGET_AUDIENCE,
  GLOBAL_FIELD_NAMES.TARGET_CHANNELS,
  GLOBAL_FIELD_NAMES.MAIN_COMPETITORS,
  GLOBAL_FIELD_NAMES.PROJECTED_ANNUAL_INCOME,
  GLOBAL_FIELD_NAMES.FORECASTED_PROFITABILITY,
  GLOBAL_FIELD_NAMES.PROJECT_PAYBACK_PERIOD,
  GLOBAL_FIELD_NAMES.TOTAL_COST,
  GLOBAL_FIELD_NAMES.FUNDING_AMOUNT,
  GLOBAL_FIELD_NAMES.PERCENTAGE_OF_FUNDING,
];

export const executiveSummaryGlobalFieldNames = [
  GLOBAL_FIELD_NAMES.ADDRESS,
  GLOBAL_FIELD_NAMES.ANNUAL_INCOME,
  GLOBAL_FIELD_NAMES.MAIN_GOALS,
  GLOBAL_FIELD_NAMES.PROJECT_BRIEF_DESCRIPTION,
  GLOBAL_FIELD_NAMES.STRATEGY_FOR_ACHIEVING_GOALS,
  GLOBAL_FIELD_NAMES.COMPANY_NAME,
  GLOBAL_FIELD_NAMES.REGISTRATION_DATE,
  GLOBAL_FIELD_NAMES.COMPANY_SECTOR,
  GLOBAL_FIELD_NAMES.MISSION,
  GLOBAL_FIELD_NAMES.MAIN_PRODUCTS_OR_SERVICES,
  GLOBAL_FIELD_NAMES.COMPETITIVE_ADVANTAGE,
  GLOBAL_FIELD_NAMES.PRODUCT_DEVELOPMENT_PLANS,
  GLOBAL_FIELD_NAMES.TARGET_MARKET,
  GLOBAL_FIELD_NAMES.TARGET_AUDIENCE,
  GLOBAL_FIELD_NAMES.TARGET_CHANNELS,
  GLOBAL_FIELD_NAMES.MAIN_COMPETITORS,
  GLOBAL_FIELD_NAMES.ANNUAL_INCOME,
  GLOBAL_FIELD_NAMES.PROJECTED_ANNUAL_INCOME,
  GLOBAL_FIELD_NAMES.FORECASTED_PROFITABILITY,
  GLOBAL_FIELD_NAMES.PROJECT_PAYBACK_PERIOD,
  GLOBAL_FIELD_NAMES.TOTAL_COST,
  GLOBAL_FIELD_NAMES.FUNDING_AMOUNT,
  GLOBAL_FIELD_NAMES.PERCENTAGE_OF_FUNDING,
  ALL_FIELD_NAMES.COMPANY_DESCRIPTION.COMPANY_OWNERS,
  ALL_FIELD_NAMES.COMPANY_DESCRIPTION.HISTORY,
  ALL_FIELD_NAMES.COMPANY_DESCRIPTION.RESOURCES_AND_ASSETS,
  ALL_FIELD_NAMES.FINANCIAL_INFORMATION.AVERAGE_ANNUAL_PROFIT,
  ALL_FIELD_NAMES.FINANCIAL_INFORMATION.INTERNAL_RATE_OF_RETURN,
  ALL_FIELD_NAMES.FINANCIAL_INFORMATION.PROJECTED_ANNUAL_PROFIT,
  ALL_FIELD_NAMES.FINANCIAL_INFORMATION.RETURN_ON_INVESTMENT,
  ALL_FIELD_NAMES.PRODUCTS_OR_SERVICES.PRODUCTS_VALUE,
  ALL_FIELD_NAMES.MARKET_AND_CUSTOMERS.DYNAMICS,
  ALL_FIELD_NAMES.ORGANIZATION_AND_TEAM.MEMBERS,
];

export const aboutCompanyGlobalFieldNames = [
  GLOBAL_FIELD_NAMES.COMPANY_BRIEF_DESCRIPTION,
  GLOBAL_FIELD_NAMES.COMPANY_NAME,
  GLOBAL_FIELD_NAMES.COMPANY_SECTOR,
  GLOBAL_FIELD_NAMES.NUMBER_OF_EMPLOYEES,
  GLOBAL_FIELD_NAMES.ADDRESS,
  GLOBAL_FIELD_NAMES.REGISTRATION_DATE,
  GLOBAL_FIELD_NAMES.MISSION,
  GLOBAL_FIELD_NAMES.COMPANY_STRENGTHS,
  GLOBAL_FIELD_NAMES.COMPANY_WEAKNESSES,
];

export const marketAnalysisGlobalFieldNames = [
  ALL_FIELD_NAMES.MARKET_OVERVIEW.MAIN_MARKET_OVERVIEW,
  ALL_FIELD_NAMES.MARKET_OVERVIEW.SERVICES_PRODUCTS_SUMMARY,
  ALL_FIELD_NAMES.MARKET_OVERVIEW.ACTUAL_AND_FORECASTED_CONSUMPTION,
  ALL_FIELD_NAMES.MARKET_OVERVIEW.MARKET_TRENDS,
  ALL_FIELD_NAMES.MARKET_OVERVIEW.SALES_METHOD,
  ALL_FIELD_NAMES.MARKET_OVERVIEW.MARKET_STRUCTURE_DESCRIPTION,
  ALL_FIELD_NAMES.MARKET_OVERVIEW.MARKET_GROWTH_FACTORS,
  ALL_FIELD_NAMES.MARKET_OVERVIEW.PRICE_STRATEGIES,
  ALL_FIELD_NAMES.MARKET_OVERVIEW.AVERAGE_PRICES_TITLE,
  ALL_FIELD_NAMES.CONSUMER_NEEDS.HOW_CUSTOMERS_SATISFIED,
  ALL_FIELD_NAMES.CONSUMER_NEEDS.DEMAND,
  ALL_FIELD_NAMES.CONSUMER_NEEDS.PURCHASING_DECISION,
  ALL_FIELD_NAMES.CONSUMER_NEEDS.B2B.INDUSTRY,
  ALL_FIELD_NAMES.CONSUMER_NEEDS.B2B.ANNUAL_REVENUE,
  ALL_FIELD_NAMES.CONSUMER_NEEDS.B2B.NUMBER_OF_EMPLOYERS,
  ALL_FIELD_NAMES.CONSUMER_NEEDS.B2B.REGION,
  ALL_FIELD_NAMES.CONSUMER_NEEDS.B2B.CUSTOMER_BUYING_BEHAVIOR,
  ALL_FIELD_NAMES.CONSUMER_NEEDS.B2C.AGE,
  ALL_FIELD_NAMES.CONSUMER_NEEDS.B2C.ANNUAL_INCOME,
  ALL_FIELD_NAMES.CONSUMER_NEEDS.B2C.NEEDS_AND_PROBLEMS,
  ALL_FIELD_NAMES.CONSUMER_NEEDS.B2C.PERSONAL_INTERESTS,
  ALL_FIELD_NAMES.CONSUMER_NEEDS.B2C.PROFESSION,
  ALL_FIELD_NAMES.CONSUMER_NEEDS.B2C.PURCHASING_HABITS,
  ALL_FIELD_NAMES.COMPETITIVE_ANALYSIS.COMPETITORS,
  ALL_FIELD_NAMES.COMPETITIVE_ANALYSIS.BARRIERS,
];

export const managementAndOrganizationsGlobalFieldNames = [
  ALL_FIELD_NAMES.ORGANIZATION_AND_TEAM.MANAGEMENT_TEAM_HISTORY,
  ALL_FIELD_NAMES.STAFF_ORGANIZATION.NUMBER_OF_STAFF,
  ALL_FIELD_NAMES.STAFF_ORGANIZATION.LEVEL1_DEPARTMENT,
  ALL_FIELD_NAMES.STAFF_ORGANIZATION.LEVEL2_DEPARTMENT,
  ALL_FIELD_NAMES.STAFF_ORGANIZATION.LEVEL3_DEPARTMENT,
  ALL_FIELD_NAMES.STAFF_ORGANIZATION.ADDITIONAL_HIRES,
  ALL_FIELD_NAMES.STAFF_ORGANIZATION.SALARY_POLICY,
];

export const businessOperationsGlobalFieldNames = [
  GLOBAL_FIELD_NAMES.PRODUCTS,
  GLOBAL_FIELD_NAMES.COMPETITIVE_ADVANTAGE,
];

export const forInvestorsSectionsMap = {
  [FOR_INVESTORS_SECTIONS.OVERVIEW]: {
    chapterName: BUSINESS_TOOL_SECTIONS.OVERVIEW,
    globalFields: overviewGlobalFieldNames,
    fieldsToIgnore: [concatWithDot(overviewCompanyPrefix, COMPANY_OVERVIEW_NAMES.FILE)],
    additionalFieldsToCheck: [],
    checkOnlyTheseFields: overviewGlobalFieldNames,
  },
  [FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY]: {
    chapterName: BUSINESS_TOOL_SECTIONS.EXECUTIVE_SUMMARY,
    globalFields: executiveSummaryGlobalFieldNames,
    fieldsToIgnore: [
      EXECUTIVE_SUMMARY_MARKET_NAMES.COMPETITION_PLAN,
      EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.ASSETS_SIZE,
      EXECUTIVE_SUMMARY_RISKS_NAMES.MAIN_RISKS,
      EXECUTIVE_SUMMARY_RISKS_NAMES.MEASURES,
    ],
    additionalFieldsToCheck: [],
    checkOnlyTheseFields: [],
  },
  [FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT]: {
    chapterName: BUSINESS_TOOL_SECTIONS.ABOUT_COMPANY,
    globalFields: aboutCompanyGlobalFieldNames,
    fieldsToIgnore: [
      ABOUT_COMPANY_HISTORY_NAMES.BUSINESS_IDEA_CONCEPTION,
      ABOUT_COMPANY_HISTORY_NAMES.MOTIVATION,
      ABOUT_COMPANY_MISSION_NAMES.VISION_OF_FUTURE,
      ABOUT_COMPANY_MISSION_NAMES.CORE_VALUES,
      GLOBAL_FIELD_NAMES.REGISTRATION_DATE,
      GLOBAL_FIELD_NAMES.MISSION,
      'IMPLEMENTATION_PLAN.stages[0].status.value',
      'IMPLEMENTATION_PLAN.stages[0].status.label',
    ],
    additionalFieldsToCheck: [BUSINESS_TOOL_SECTIONS.IMPLEMENTATION_PLAN],
    checkOnlyTheseFields: [],
  },
  [FOR_INVESTORS_SECTIONS.MARKET_ANALYSIS]: {
    chapterName: BUSINESS_TOOL_SECTIONS.MARKET_ANALYSIS,
    globalFields: marketAnalysisGlobalFieldNames,
    fieldsToIgnore: [
      MARKET_ANALYSIS_OVERVIEW_NAMES.AVERAGE_PRICES_CURRENCY,
      B2C_NAMES.GENDER,
      AVERAGE_PRICES_CHART_NAMES.AVERAGE_PRICES_REGIONS_HEADINGS,
      ALL_FIELD_NAMES.COMPETITIVE_ANALYSIS.YOUR_COMPANY_QUALITIES.FILE,
      ALL_FIELD_NAMES.MARKET_OVERVIEW.CONSUMERS_DESCRIPTION,
      ALL_FIELD_NAMES.MARKET_OVERVIEW.MARKET_COMPETITORS,
      ALL_FIELD_NAMES.MARKET_OVERVIEW.MARKET_SHARE,
      ALL_FIELD_NAMES.MARKET_OVERVIEW.TECHNOLOGY_IMPACT,
      ALL_FIELD_NAMES.MARKET_OVERVIEW.AVERAGE_PRICES_CHART.AVERAGE_PRICES_REGIONS_ROWS,
      ALL_FIELD_NAMES.CONSUMER_NEEDS.INFLUENCING_FACTORS,
      ALL_FIELD_NAMES.CONSUMER_NEEDS.DIFFERENCES,
      ALL_FIELD_NAMES.CONSUMER_NEEDS.SURVEY,
      ALL_FIELD_NAMES.COMPETITIVE_ANALYSIS.COMPETITORS_QUALITIES,
      ALL_FIELD_NAMES.COMPETITIVE_ANALYSIS.ATTRACTING_COMPETITORS_CUSTOMERS,
      ALL_FIELD_NAMES.COMPETITIVE_ANALYSIS.COMPETITORS_DIFFERENCE,
      ALL_FIELD_NAMES.COMPETITIVE_ANALYSIS.PURCHASING_PRODUCTS,
      ALL_FIELD_NAMES.COMPETITIVE_ANALYSIS.FUTURE_EXPECTATIONS,
      ALL_FIELD_NAMES.COMPETITIVE_ANALYSIS.CHANGING_OF_CURRENT_MARKET,
      'competitiveAnalysis.comparisonItem[0].featuresForComparison',
      'competitiveAnalysis.comparisonItem[0].competitorFeaturesList',
      'competitiveAnalysis.keyCompetitors[0].customerLoyaltyLevel',
      'competitiveAnalysis.comparisonItem[0].featuresList',

      'marketOverview.currentMarketStructure[0].consumerDetails[0].monetaryShare',
      'forecastedConsumptionChart[0].tableHeadings',
      'marketOverview.currentMarketStructure[0].title',
      'marketOverview.currentMarketStructure[0].consumer',
      'marketOverview.currentMarketStructure[0].units.selectedUnits',
      'marketOverview.currentMarketStructure[0].units.volume',
      'marketOverview.currentMarketStructure[0].units.currency',
      'marketOverview.forecastedConsumptionChart[0].title',
      'marketOverview.forecastedConsumptionChart[0].region',
      'marketOverview.forecastedConsumptionChart[0].units.selectedUnits',
      'marketOverview.forecastedConsumptionChart[0].units.volume',
      'marketOverview.forecastedConsumptionChart[0].units.currency',
      'file',
    ],
    additionalFieldsToCheck: [],
    checkOnlyTheseFields: [],
  },
  [FOR_INVESTORS_SECTIONS.MARKETING_AND_SALES]: {
    chapterName: BUSINESS_TOOL_SECTIONS.MARKETING_AND_SALES,
    globalFields: [],
    fieldsToIgnore: [
      ALL_FIELD_NAMES.SALES_PLAN.TOTAL_PLANNED_PRODUCTS_VOLUME,
      ALL_FIELD_NAMES.SALES_PLAN.PLANNED_PRODUCTS_VOLUME,
      ALL_FIELD_NAMES.SALES_PLAN.STAGES,
      ALL_FIELD_NAMES.SALES_PLAN.PERFORMANCE_INDICTORS,
      ALL_FIELD_NAMES.SALES_PLAN.SALES_TEAM_STRUCTURE,
      ALL_FIELD_NAMES.SALES_PLAN.MOTIVATION_SYSTEM,
      ALL_FIELD_NAMES.MARKETING_PLAN.BUDGET,
      ALL_FIELD_NAMES.MARKETING_PLAN.BRAND_ELEMENTS,
      ALL_FIELD_NAMES.MARKETING_PLAN.TOOLS_AND_TECHNOLOGIES,
      ALL_FIELD_NAMES.MARKET_OVERVIEW.CONSUMERS_DESCRIPTION,
      ALL_FIELD_NAMES.MARKET_OVERVIEW.MARKET_COMPETITORS,
      ALL_FIELD_NAMES.MARKET_OVERVIEW.MARKET_SHARE,
      ALL_FIELD_NAMES.MARKET_OVERVIEW.TECHNOLOGY_IMPACT,
      ALL_FIELD_NAMES.MARKET_OVERVIEW.AVERAGE_PRICES_DATE,
      ALL_FIELD_NAMES.CONSUMER_NEEDS.INFLUENCING_FACTORS,
      ALL_FIELD_NAMES.CONSUMER_NEEDS.DIFFERENCES,
      ALL_FIELD_NAMES.CONSUMER_NEEDS.SURVEY,
      ALL_FIELD_NAMES.COMPETITIVE_ANALYSIS.ATTRACTING_COMPETITORS_CUSTOMERS,
      ALL_FIELD_NAMES.COMPETITIVE_ANALYSIS.COMPETITORS_DIFFERENCE,
      ALL_FIELD_NAMES.COMPETITIVE_ANALYSIS.PURCHASING_PRODUCTS,
      ALL_FIELD_NAMES.COMPETITIVE_ANALYSIS.FUTURE_EXPECTATIONS,
      ALL_FIELD_NAMES.COMPETITIVE_ANALYSIS.CHANGING_OF_CURRENT_MARKET,
    ],
    additionalFieldsToCheck: [],
    checkOnlyTheseFields: [],
  },
  [FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS]: {
    chapterName: BUSINESS_TOOL_SECTIONS.BUSINESS_OPERATIONS,
    globalFields: businessOperationsGlobalFieldNames,
    fieldsToIgnore: [
      LOCATION_AND_PREMISES_NAMES.QUALITIES,
      EQUIPMENT_NAMES.LEVEL_OF_UTILIZATION,
      EQUIPMENT_NAMES.RATIONALE_FOR_PURCHASING,
      ASSETS_NAMES.RATIONALE_FOR_PURCHASING,
      TECHNOLOGICAL_PROCESS_NAMES.QUALITIES,
      TECHNOLOGICAL_PROCESS_NAMES.COMPETING_TECHNOLOGY,
      QUALITY_NAMES.FACTORS,
      QUALITY_NAMES.METHODS,
      PARTNERS_NAMES.CRITERIA,
      PARTNERS_NAMES.KEY_SUPPLIERS,
      WORKING_RESOURCES_NAMES.AVAILABILITY,
      PRODUCTION_NAMES.PACKAGE,
      PRODUCTION_NAMES.DISPOSAL_WAIST,
      PRODUCTION_NAMES.INVOLVED_PRODUCTION,
      PRODUCTION_NAMES.OUTSOURCING_OPPORTUNITIES,
      PRODUCTION_NAMES.INVENTORY_MANAGEMENT,
      LOCATION_AND_PREMISES_NAMES.PREMISES_INFORMATION,
      PRODUCT_NAMES.PRODUCT_ID,
      'file',
      'products',
      'PRODUCTS_AND_SERVICES.description.keyFeaturesAndBenefits[0].description',
    ],
    additionalFieldsToCheck: [
      concatWithDot(
        productsAndServicesDescriptionPrefix,
        PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.PRODUCTS_OR_SERVICES_AND_THEIR_PURPOSE,
      ),
      concatWithDot(
        productsAndServicesDescriptionPrefix,
        PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.KEY_FEATURES_AND_BENEFITS,
      ),
      concatWithDot(productsAndServicesDescriptionPrefix, PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.QUALITY_STANDARDS),
      concatWithDot(
        productsAndServicesDescriptionPrefix,
        PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.QUALITY_CERTIFICATIONS,
      ),
      concatWithDot(
        productsAndServicesDescriptionPrefix,
        PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.PATENTS_OR_TRADEMARKS,
      ),
      concatWithDot(prefix, PRODUCTS_AND_SERVICES_ADVANTAGES_NAMES.PRODUCT_VALUE),
    ],
    checkOnlyTheseFields: [],
  },
  [FOR_INVESTORS_SECTIONS.MANAGEMENT_AND_ORGANIZATION]: {
    chapterName: BUSINESS_TOOL_SECTIONS.MANAGEMENT_AND_ORGANIZATION,
    globalFields: managementAndOrganizationsGlobalFieldNames,
    fieldsToIgnore: [
      MANAGEMENT_TEAM_NAMES.PERSONAL_QUALITIES,
      EXTERNAL_PARTNERS_AND_ADVISERS_NAMES.LIST_OF_EXTERNAL_PARTNERS,
      EXTERNAL_PARTNERS_AND_ADVISERS_NAMES.PARTNERS,
      EXTERNAL_PARTNERS_AND_ADVISERS_NAMES.CRITERIA,
      EXTERNAL_PARTNERS_AND_ADVISERS_NAMES.PLANS,
      STAFF_ORGANIZATION_NAMES.APPROACHES,
      STAFF_ORGANIZATION_NAMES.ATTRACTING_DIFFICULTIES,
      STAFF_ORGANIZATION_NAMES.RETENTION_DIFFICULTIES,
      STAFF_ORGANIZATION_NAMES.DEVELOPMENT_PROGRAMS,
      'managementTeam.skills',
      'file',
    ],
    additionalFieldsToCheck: [],
    checkOnlyTheseFields: [],
  },
  [FOR_INVESTORS_SECTIONS.RAISING_AND_ALLOCATING_FUNDS]: {
    chapterName: BUSINESS_TOOL_SECTIONS.RAISING_AND_ALLOCATING_FUNDS,
    globalFields: [
      GLOBAL_FIELD_NAMES.TOTAL_COST,
      GLOBAL_FIELD_NAMES.PERCENTAGE_OF_FUNDING,
      GLOBAL_FIELD_NAMES.FUNDING_AMOUNT,
      GLOBAL_FIELD_NAMES.INVESTMENT_AMOUNT,
    ],
    fieldsToIgnore: [
      RAISING_AND_ALLOCATING_FUNDS_NAMES.BORROW_DESCRIPTION,
      RAISING_AND_ALLOCATING_FUNDS_NAMES.LOAN_TERMS,
      RAISING_AND_ALLOCATING_FUNDS_NAMES.ACTIONS_IN_SEARCHING_FOR_FUNDING,
      RAISING_AND_ALLOCATING_FUNDS_NAMES.ATTRACTING_FINANCING_EXPERIENCE,
      RAISING_AND_ALLOCATING_FUNDS_NAMES.UTILIZING_SUPPORT_PROGRAMS,
      GLOBAL_FIELD_NAMES.FINANCED_PORTION_COST,
      'percentageOfFunding',
    ],
    additionalFieldsToCheck: [],
    checkOnlyTheseFields: [],
  },
  [FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN]: {
    chapterName: BUSINESS_TOOL_SECTIONS.FINANCIAL_PLAN,
    globalFields: [],
    fieldsToIgnore: [
      'rowItemName',
      'financialPerformance.investment.discountRate',
      ALL_FIELD_NAMES.PLANNED_EXPENSES.MONTHLY_EXPENSES.NON_OPERATING_EXPENSES,
      ALL_FIELD_NAMES.PLANNED_EXPENSES.MONTHLY_EXPENSES.NON_OPERATING_GROWTH_RATE,
      ALL_FIELD_NAMES.PLANNED_EXPENSES.MONTHLY_EXPENSES.NON_OPERATING_REVENUE,
      REVENUE_PLAN_NAMES.PLANNED_PRODUCTS_VOLUME_TOTAL,
      REVENUE_PLAN_NAMES.PLANNED_PRODUCTS_VOLUME,
      INVESTMENT_FORM_NAMES.INVESTMENT_TABLE,
      PROFITABILITY_FORM_NAMES.PROFITABILITY_TABLE,
      PROFITABILITY_FORM_NAMES.PROFITABILITY_TOTAL,
      PROFITABILITY_FORM_NAMES.PROFITABILITY_VARIANTS,
      LIQUIDITY_FORM_NAMES.LIQUIDITY_TABLE,
      LIQUIDITY_FORM_NAMES.LIQUIDITY_VARIANTS,
      EFFICIENCY_FORM_NAMES.EFFICIENCY_TABLE,
      EFFICIENCY_FORM_NAMES.EFFICIENCY_VARIANTS,
      SOLVENCY_FORM_NAMES.SOLVENCY_TABLE,
      SOLVENCY_FORM_NAMES.SOLVENCY_VARIANTS,
      PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES.ASSETS,
      PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES.LIABILITIES_AND_EQUITY,
      PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES.COMPANY_MAIN_COMPONENTS,
      PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES.SHORT_TERM_LIABILITIES_FINANCE,
      PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES.NON_CURRENT_ASSETS_CHANGE,
      PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES.STRUCTURE_OF_NON_CURRENT_ASSETS,
      PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES.SHORT_TERM_LIABILITIES_MAIN_COMPONENTS,
      PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES.SHORT_TERM_FINANCING_SOURCES,
      PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES.LONG_TERM_LIABILITIES_MAIN_COMPONENTS,
      PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES.COMPANY_EQUITY_STRUCTURE,
      EXPENSE_TYPE_NAMES.TOTAL_EXPENSES,
      PROFIT_AND_LOSS_PROJECTION_FORM_NAMES.TABLE,
      PROFIT_AND_LOSS_PROJECTION_FORM_NAMES.ESTIMATED_TAX_RATE,
      CALENDAR_PLAN_NAMES.TOTAL,
      CALENDAR_PLAN_NAMES.CURRENCY,
      FUNDING_DIRECTIONS_NAMES.EQUIPMENT_PURCHASE_SUB_ROW,
      FUNDING_DIRECTIONS_NAMES.CONSTRUCTION_SUB_ROW,
      FUNDING_DIRECTIONS_NAMES.MARKETING_AND_SALES_SUB_ROWS,
      FUNDING_DIRECTIONS_NAMES.R_AND_D_SUB_ROWS,
      FUNDING_DIRECTIONS_NAMES.OTHER_SUB_ROW,
      FUNDING_DIRECTIONS_NAMES.WORKING_CAPITAL_SUB_ROW,
      FUNDING_DIRECTIONS_NAMES.VARIANTS,
      PROJECTED_CASH_FLOW_FORM_NAMES.SELECTED_TYPE,
      NET_SALES_NAMES.NET_SALES,
      NET_INCOME_NAMES.NET_INCOME,
      COST_OF_SALES_FORM_NAMES.CONST_OF_SALES_CURRENCY,
      R_AND_D_FORM_NAMES.R_AND_D_CURRENCY,
      SALES_AND_MARKETING_FORM_NAMES.SALES_AND_MARKETING_CURRENCY,
      GENERAL_AND_ADMINISTRATIVE_FORM_NAMES.GENERAL_AND_ADMINISTRATIVE_CURRENCY,
      COST_OF_EACH_UNIT_FORM_NAMES.CONST_OF_EACH_UNIT_CURRENCY,
      PERSONNEL_EXPENSES_FORM_NAMES.PERSONNEL_EXPENSES_VARIANTS,
      PERSONNEL_EXPENSES_FORM_NAMES.PERSONNEL_EXPENSES_HEADER,
      OPERATING_ACTIVITIES_NAMES.INTEREST_RECEIVED,
      OPERATING_ACTIVITIES_NAMES.INTEREST_PAID,
      OPERATING_ACTIVITIES_NAMES.CASH_PAID_OTHER_OPERATING_EXPENSES,
      OPERATING_ACTIVITIES_NAMES.NET_CASH_OPERATING_ACTIVITIES,
      OPERATING_ACTIVITIES_NAMES.CASH_PAID_SUPPLIERS,
      OPERATING_ACTIVITIES_NAMES.INCOME_TAXES_PAID,
      OPERATING_ACTIVITIES_NAMES.CASH_RECEIVED_CUSTOMERS,
      OPERATING_ACTIVITIES_NAMES.CASH_PAID_EMPLOYEES,
      INVESTING_ACTIVITIES_NAMES.PURCHASE_PROPERTY_PLANT_EQUIPMENT,
      FINANCING_ACTIVITIES_NAMES.PROCEEDS_ISSUANCE_DEBT,
      FINANCING_ACTIVITIES_NAMES.REPAYMENT_DEBT,
      FINANCING_ACTIVITIES_NAMES.PROCEEDS_ISSUANCE_EQUITY,
      PROJECTED_CASH_FLOW_FORM_NAMES.IN_DIRECT,
      INITIAL_ASSETS_NAMES.CURRENT_ASSETS,
      INITIAL_ASSETS_NAMES.NON_CURRENT_ASSETS,
      INITIAL_LIABILITIES_NAMES.CURRENT_LIABILITIES,
      INITIAL_LIABILITIES_NAMES.NON_CURRENT_LIABILITIES,
      EQUITY_NAMES.ACCUMULATED_OTHER_COMPREHENSIVE_INCOME,
      EQUITY_NAMES.RESERVES,
      EQUITY_NAMES.ADDITIONAL_PAID_IN_CAPITAL,
      EQUITY_NAMES.RETAINED_EARNINGS,
      EQUITY_NAMES.TOTAL_STOCKHOLDERS_EQUITY,
      OPERATING_EXPENSES_NAMES.R_AND_D,
      OPERATING_EXPENSES_NAMES.OTHER_OPERATING_EXPENSES,
      OPERATING_EXPENSES_NAMES.TOTAL_OPERATING_EXPENSES,
      OPERATING_EXPENSES_NAMES.SALES_AND_MARKETING,
      OPERATING_EXPENSES_NAMES.GENERAL_AND_ADMINISTRATIVE,
      PROJECTED_CASH_FLOW_FORM_NAMES.AMORTIZATIONS,
      PROJECTED_CASH_FLOW_FORM_NAMES.DEPRECATION,
      TOTAL_FIELDS.CASH_EQUIVALENTS_BEGINNING_PERIOD.name,
      TOTAL_FIELDS.CASH_EQUIVALENTS_END_PERIOD.name,
      TOTAL_FIELDS.NET_INCREASE_DECREASE_CASH_EQUIVALENTS.name,
      LIQUIDITY_FORM_NAMES.ANTICIPATED_OUTCOME,
      EFFICIENCY_FORM_NAMES.ANTICIPATED_OUTCOME,
      SOLVENCY_FORM_NAMES.ANTICIPATED_OUTCOME,
      PERIOD_NAMES.HALF_VALUES,
      PERIOD_NAMES.MONTH_VALUES,
      PERIOD_NAMES.QUARTER_VALUES,
      PERIOD_NAMES.YEAR_VALUES,
      'openingBalanceSheets.isEqual',
    ],
    additionalFieldsToCheck: [],
    checkOnlyTheseFields: [],
  },
};
